<div class="p-6 max-w-7xl mx-auto">

  <!-- Encabezado -->
  <div class="mb-4">
    <h1 class="text-2xl font-bold text-gray-900 flex items-center gap-2">
      <i class="fas fa-cloud text-blue-600"></i> Integración SAP
    </h1>
    <p class="text-sm text-gray-600">Panel de control, alta de clientes, monitoreo y configuración de SAP (Business Partner).</p>
  </div>

  <!-- Pestañas -->
  <div class="border-b border-gray-200 mb-5 flex flex-wrap gap-1">
    <button (click)="setTab('resumen')" [class.tab-active]="tab==='resumen'" class="tab-btn">Resumen</button>
    <button (click)="setTab('clientes')" [class.tab-active]="tab==='clientes'" class="tab-btn">Clientes</button>
    <button (click)="setTab('config')" [class.tab-active]="tab==='config'" class="tab-btn">Configuración</button>
  </div>

  <!-- ===================== RESUMEN ===================== -->
  <div *ngIf="tab==='resumen'">
    <div class="flex items-center justify-between mb-3">
      <div class="text-xs text-gray-500" *ngIf="calculadoAt">Actualizado: {{ calculadoAt | date:'short' }}</div>
      <button (click)="refreshKpis()" [disabled]="loadingKpis" class="btn-refresh">
        <i class="fas fa-sync-alt" [class.fa-spin]="loadingKpis"></i> Refrescar
      </button>
    </div>

    <div *ngIf="calculando" class="mb-4 bg-blue-50 border border-blue-200 text-blue-700 text-sm rounded-lg px-4 py-2">
      <i class="fas fa-spinner fa-spin"></i> Calculando el universo de clientes… (aparecerá en unos segundos)
    </div>

    <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5">
      <div class="kpi-card"><div class="kpi-num text-green-600">{{ kpis?.creados ?? '—' }}</div><div class="kpi-lbl">Creados en SAP</div></div>
      <div class="kpi-card"><div class="kpi-num text-amber-600">{{ kpis?.sin_registrar ?? '—' }}</div><div class="kpi-lbl">Sin registrar</div></div>
      <div class="kpi-card"><div class="kpi-num text-red-600">{{ kpis?.con_error ?? '—' }}</div><div class="kpi-lbl">Con error</div></div>
      <div class="kpi-card"><div class="kpi-num text-blue-600">{{ kpis?.cobertura != null ? (kpis?.cobertura + '%') : '—' }}</div><div class="kpi-lbl">Cobertura</div></div>
    </div>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <div class="kpi-card"><div class="kpi-num text-gray-800">{{ kpis?.universo ?? '—' }}</div><div class="kpi-lbl">Universo (con crédito)</div></div>
      <div class="kpi-card"><div class="kpi-num text-gray-800">{{ kpis?.creados_hoy ?? '—' }}</div><div class="kpi-lbl">Creados hoy</div></div>
      <div class="kpi-card"><div class="kpi-num text-gray-800">{{ kpis?.creados_semana ?? '—' }}</div><div class="kpi-lbl">Creados esta semana</div></div>
      <div class="kpi-card">
        <div class="kpi-num" [class.text-green-600]="salud?.configurado" [class.text-gray-400]="!salud?.configurado">
          <i class="fas" [class.fa-circle-check]="salud?.configurado" [class.fa-circle-xmark]="!salud?.configurado"></i>
        </div>
        <div class="kpi-lbl">Salud SAP</div>
      </div>
    </div>

    <div class="grid md:grid-cols-2 gap-4">
      <div class="panel">
        <h3 class="panel-title">Estado del endpoint</h3>
        <div class="text-sm text-gray-700 space-y-1">
          <div>Destino: <span class="font-mono text-xs">{{ salud?.base_url || '—' }}</span></div>
          <div>Habilitado: <span [class.text-green-600]="salud?.enabled" [class.text-red-600]="!salud?.enabled">{{ salud?.enabled ? 'Sí' : 'No' }}</span></div>
          <div>Última llamada OK: {{ salud?.ultima_llamada_ok ? (salud?.ultima_llamada_ok | date:'short') : '—' }}</div>
        </div>
      </div>
      <div class="panel">
        <h3 class="panel-title">Errores por motivo (30 días)</h3>
        <div *ngIf="erroresMotivo.length === 0" class="text-sm text-gray-400">Sin errores registrados.</div>
        <div *ngFor="let e of erroresMotivo" class="flex justify-between text-sm py-1 border-b border-gray-100">
          <span class="text-gray-700">{{ e.motivo }}</span><span class="font-semibold text-red-600">{{ e.total }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================== CLIENTES ===================== -->
  <div *ngIf="tab==='clientes'">
    <div class="flex flex-wrap items-center gap-2 mb-3">
      <button (click)="changeStatus('todos')" [class.filter-active]="clientStatus==='todos'" class="filter-btn">Todos (en SAP)</button>
      <button (click)="changeStatus('creados')" [class.filter-active]="clientStatus==='creados'" class="filter-btn">Creados</button>
      <button (click)="changeStatus('error')" [class.filter-active]="clientStatus==='error'" class="filter-btn">Con error</button>
      <button (click)="changeStatus('sin_registrar')" [class.filter-active]="clientStatus==='sin_registrar'" class="filter-btn">Sin registrar</button>
    </div>

    <!-- Sub-filtro por Tipo de error (solo dentro de "Con error") -->
    <div class="flex flex-wrap items-center gap-2 mb-3" *ngIf="clientStatus==='error'">
      <span class="text-xs text-gray-500 mr-1">Tipo de error:</span>
      <button (click)="changeErrorTipo('')" [class.filter-active]="clientErrorTipo===''" class="filter-btn">Todos</button>
      <button (click)="changeErrorTipo('DATOS')" [class.filter-active]="clientErrorTipo==='DATOS'" class="filter-btn" title="Errores de datos del cliente. El cron NO los reintenta (hay que corregir el dato).">Datos incompletos</button>
      <button (click)="changeErrorTipo('TRANSITORIO')" [class.filter-active]="clientErrorTipo==='TRANSITORIO'" class="filter-btn" title="Errores temporales y reintentables: incluye 'Fuera de horario'. El cron SÍ los reintenta.">Temporal (reintenta)</button>
    </div>

    <div class="flex flex-wrap items-center gap-2 mb-3">
      <input [(ngModel)]="search" (ngModelChange)="onSearchInput()" (keyup.enter)="buscar()" placeholder="Buscar por cédula, nombre, apellido o Business Partner…"
             class="border border-gray-300 rounded-lg px-3 py-2 text-sm flex-1 min-w-[220px]" />
      <button (click)="buscar()" class="btn-primary"><i class="fas fa-search"></i> Buscar</button>
      <button *ngIf="search" (click)="limpiarBusqueda()" class="btn-ghost">Limpiar</button>
      <button (click)="loadClients(page)" [disabled]="loadingClients" class="btn-refresh">
        <i class="fas fa-sync-alt" [class.fa-spin]="loadingClients"></i> Refrescar
      </button>
    </div>

    <!-- Reporte de la pestaña: clientes con error (filtro "Con error") o creados (resto). Export xlsx por rango o TODOS -->
    <div class="panel mb-4">
      <div class="flex items-start justify-between flex-wrap gap-3">
        <div *ngIf="clientStatus==='error'">
          <div class="text-sm font-semibold text-gray-800"><i class="fas fa-file-excel text-green-600 mr-1"></i> Reporte de clientes con error en SAP</div>
          <div class="text-xs text-gray-500 mt-1">Descarga en Excel los errores que respondió SAP cuando nuestro request estaba bien: mensaje de SAP, veces, estado actual, lo que se envió y la respuesta.</div>
          <div class="text-xs text-gray-400 mt-1">El rango filtra por el día del error. Es un historial: incluye clientes que luego se crearon o modificaron bien (Estado actual = Resuelto). No incluye errores por datos nuestros, por eso puede dar menos que el total de "Con error".</div>
        </div>
        <div *ngIf="clientStatus!=='error'">
          <div class="text-sm font-semibold text-gray-800"><i class="fas fa-file-excel text-green-600 mr-1"></i> Reporte de clientes creados en SAP</div>
          <div class="text-xs text-gray-500 mt-1">Descarga en Excel: nombre y apellido, cédula, fecha de aprobación y fecha de creación en SAP.</div>
        </div>
        <button (click)="exportAllReport()" [disabled]="downloadingReport" class="btn-ghost whitespace-nowrap"
                [title]="clientStatus==='error' ? 'Descarga todo el historial de errores de SAP.' : 'Descarga TODOS los clientes creados en SAP.'">
          <i class="fas fa-database mr-1"></i>
          <ng-container *ngIf="clientStatus==='error'">Exportar todo el historial</ng-container>
          <ng-container *ngIf="clientStatus!=='error'">Exportar todos ({{ (kpis?.creados ?? 0) | number }})</ng-container>
        </button>
      </div>

      <div class="flex flex-wrap items-end gap-3 mt-3 pt-3 border-t border-gray-100">
        <div class="flex flex-col">
          <label class="text-xs text-gray-500 mb-1">Desde</label>
          <input type="date" [(ngModel)]="reportInitDate" class="border border-gray-300 rounded-lg px-3 py-2 text-sm" />
        </div>
        <div class="flex flex-col">
          <label class="text-xs text-gray-500 mb-1">Hasta</label>
          <input type="date" [(ngModel)]="reportEndDate" class="border border-gray-300 rounded-lg px-3 py-2 text-sm" />
        </div>
        <button (click)="exportReport()" [disabled]="downloadingReport || !reportInitDate || !reportEndDate" class="btn-primary whitespace-nowrap">
          <i class="fas mr-1" [class.fa-download]="!downloadingReport" [class.fa-spinner]="downloadingReport" [class.fa-spin]="downloadingReport"></i> Exportar rango
        </button>
      </div>
    </div>

    <div *ngIf="clientStatus==='sin_registrar' && !search" class="mb-3 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded px-3 py-2">
      Listar todos los "sin registrar" puede tardar unos segundos. Para ir directo a un cliente, busca por cédula.
    </div>

    <div class="bg-white border border-gray-200 rounded-lg overflow-x-auto">
      <table class="w-full text-sm">
        <thead class="bg-gray-50 text-gray-600">
          <tr>
            <th class="th">Cliente</th><th class="th">Business Partner</th><th class="th">Estado</th>
            <th class="th">Tipo de error</th>
            <th class="th">Creado</th><th class="th">Modificado</th><th class="th"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loadingClients"><td colspan="6" class="td text-center text-gray-400 py-6"><i class="fas fa-spinner fa-spin"></i> Cargando…</td></tr>
          <tr *ngIf="!loadingClients && clients.length===0"><td colspan="6" class="td text-center text-gray-400 py-6">Sin resultados.</td></tr>
          <tr *ngFor="let c of clients" (click)="openDrawer(c)" class="border-t border-gray-100 hover:bg-blue-50 cursor-pointer">
            <td class="td">
              <div class="font-medium text-gray-900">{{ c.name }} {{ c.lastName }}</div>
              <div class="text-xs text-gray-400 font-mono">{{ c.code }}</div>
            </td>
            <td class="td font-mono text-xs">{{ c.business_partner || '—' }}</td>
            <td class="td">
              <span class="badge" [ngClass]="estadoClass(c)">{{ estadoLabel(c) }}</span>
              <span *ngIf="errorDeSync(c)" class="badge badge-pend ml-1" title="Está en SAP, pero un modify posterior falló">⚠ sync</span>
            </td>
            <td class="td">
              <span *ngIf="hayError(c)" class="badge" [ngClass]="tipoErrorClass(c)" [title]="c.last_error || ''">{{ tipoErrorLabel(c) }}</span>
              <span *ngIf="!hayError(c)" class="text-gray-300">—</span>
            </td>
            <td class="td text-xs">{{ c.fe_c ? (c.fe_c | date:'short') : '—' }}</td>
            <td class="td text-xs">{{ c.fe_m ? (c.fe_m | date:'short') : '—' }}</td>
            <td class="td text-right"><i class="fas fa-chevron-right text-gray-300"></i></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex items-center justify-between mt-3 text-sm text-gray-600">
      <div>Total: <span class="font-semibold">{{ clientsTotal ?? '—' }}</span></div>
      <div class="flex items-center gap-2">
        <button (click)="prevPage()" [disabled]="page<=1" class="btn-ghost">Anterior</button>
        <span>Página {{ page }} / {{ totalPages }}</span>
        <button (click)="nextPage()" [disabled]="page>=totalPages" class="btn-ghost">Siguiente</button>
      </div>
    </div>
  </div>

  <!-- ===================== CONFIG ===================== -->
  <div *ngIf="tab==='config'">
    <div *ngIf="loadingConfig" class="text-gray-400 text-sm"><i class="fas fa-spinner fa-spin"></i> Cargando…</div>

    <div *ngIf="configEdit" class="panel max-w-2xl">
      <h3 class="panel-title">Configuración del endpoint SAP</h3>
      <p class="text-xs text-gray-500 mb-3">Cambia la <b>URL base</b> para apuntar a SAP real o al simulador. Si cambias la base, usa <b>“Regenerar URLs desde la base”</b> para recalcular las rutas de crear/modificar/CSRF.</p>

      <div class="grid gap-3">
        <div>
          <label class="text-xs text-gray-500">URL base</label>
          <input [(ngModel)]="configEdit.base_url" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono" placeholder="https://… o http://localhost:8090">
        </div>
        <div>
          <label class="text-xs text-gray-500">Ruta del servicio (service path)</label>
          <input [(ngModel)]="configEdit.service_path" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono" placeholder="/sap/opu/odata/sap/API_BUSINESS_PARTNER">
        </div>

        <div class="flex items-center gap-2">
          <button type="button" (click)="regenerarUrls()" class="text-sm px-3 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"><i class="fas fa-rotate"></i> Regenerar URLs desde la base</button>
        </div>

        <div>
          <label class="text-xs text-gray-500">URL de token CSRF</label>
          <input [(ngModel)]="configEdit.url_csrf" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono">
        </div>
        <div>
          <label class="text-xs text-gray-500">URL de crear</label>
          <input [(ngModel)]="configEdit.url_create" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono">
        </div>
        <div>
          <label class="text-xs text-gray-500">URL de modificar <span class="text-gray-400">(usa <code>{{ '{bp}' }}</code> donde va el Business Partner)</span></label>
          <input [(ngModel)]="configEdit.url_modify" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono">
        </div>

        <div class="grid grid-cols-2 gap-3">
          <div>
            <label class="text-xs text-gray-500">Método crear</label>
            <select [(ngModel)]="configEdit.method_create" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm">
              <option>POST</option><option>PUT</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-gray-500">Método modificar</label>
            <select [(ngModel)]="configEdit.method_modify" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm">
              <option>PATCH</option><option>PUT</option>
            </select>
          </div>
        </div>

        <div>
          <label class="text-xs text-gray-500">Usuario (Basic Auth)</label>
          <input [(ngModel)]="configEdit.auth_user" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono">
        </div>
        <div>
          <label class="text-xs text-gray-500">Clave (Basic Auth) <span class="text-gray-400">— dejar vacío para mantener la guardada{{ config?.has_auth_pass ? ' (ya hay una)' : '' }}</span></label>
          <input type="password" [(ngModel)]="configEdit.auth_pass" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono" placeholder="••••••">
        </div>

        <div class="flex items-center gap-6">
          <label class="flex items-center gap-2 text-sm"><input type="checkbox" [(ngModel)]="configEdit.use_csrf"> Usa CSRF</label>
          <label class="flex items-center gap-2 text-sm"><input type="checkbox" [(ngModel)]="configEdit.enabled"> Integración habilitada (apaga TODO)</label>
        </div>

        <div class="border-t border-gray-200 pt-3">
          <div class="text-xs font-semibold text-gray-600 mb-2">Acciones automáticas</div>
          <div class="flex flex-wrap items-center gap-6">
            <label class="flex items-center gap-2 text-sm"><input type="checkbox" [(ngModel)]="configEdit.crear_activo"> Crear en SAP</label>
            <label class="flex items-center gap-2 text-sm"><input type="checkbox" [(ngModel)]="configEdit.modificar_activo"> Modificar en SAP</label>
          </div>
          <p class="text-xs text-gray-400 mt-1">Apagan cada acción por separado. Lo que quede pendiente lo recupera el cron cuando se vuelva a prender.</p>
        </div>

        <div class="border-t border-gray-200 pt-3">
          <div class="text-xs font-semibold text-gray-600 mb-2">Cron de sincronización (crea faltantes y actualiza cambiados)</div>
          <div class="flex flex-wrap items-end gap-4">
            <label class="flex items-center gap-2 text-sm"><input type="checkbox" [(ngModel)]="configEdit.cron_activo"> Cron activo</label>
            <div>
              <label class="text-xs text-gray-500 block">Hora (0–23, Venezuela)</label>
              <input type="number" min="0" max="23" [(ngModel)]="configEdit.cron_hora" class="w-24 border border-gray-300 rounded-lg px-3 py-2 text-sm">
            </div>
            <div>
              <label class="text-xs text-gray-500 block">Frecuencia (cada N horas; 24 = diario)</label>
              <input type="number" min="1" max="24" [(ngModel)]="configEdit.cron_frecuencia_horas" class="w-28 border border-gray-300 rounded-lg px-3 py-2 text-sm">
            </div>
          </div>
          <p class="text-xs text-gray-400 mt-1">Con frecuencia 24 corre una vez al día a la hora indicada; con menos, cada N horas.</p>
        </div>
      </div>

      <div class="mt-4 flex items-center gap-3">
        <button (click)="saveConfig()" [disabled]="savingConfig" class="btn-primary"><i class="fas fa-save"></i> {{ savingConfig ? 'Guardando…' : 'Guardar configuración' }}</button>
        <button (click)="loadConfig()" [disabled]="savingConfig" class="text-sm px-3 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50">Descartar cambios</button>
        <span *ngIf="configMsg" class="text-sm" [class.text-green-600]="configMsg.ok" [class.text-red-600]="!configMsg.ok">{{ configMsg.text }}</span>
      </div>
    </div>
  </div>


</div>

<!-- ===================== DRAWER (detalle del cliente, derecha) ===================== -->
<div *ngIf="drawerOpen" class="drawer-overlay" (click)="closeDrawer()"></div>
<aside class="drawer" [class.drawer-open]="drawerOpen" *ngIf="sel">
  <div class="drawer-head">
    <div class="min-w-0">
      <div class="text-lg font-bold text-gray-900 truncate">{{ sel.name }} {{ sel.lastName }}</div>
      <div class="text-xs text-gray-400 font-mono truncate">{{ sel.code }}</div>
      <div class="mt-1"><span class="badge" [ngClass]="estadoClass(sel)">{{ estadoLabel(sel) }}</span></div>
    </div>
    <button (click)="closeDrawer()" class="drawer-close"><i class="fas fa-times"></i></button>
  </div>

  <div class="drawer-tabs">
    <button (click)="drawerTab='info'" [class.dtab-active]="drawerTab==='info'" class="dtab">Información</button>
    <button (click)="drawerTab='bitacora'" [class.dtab-active]="drawerTab==='bitacora'" class="dtab">Bitácora</button>
  </div>

  <div class="drawer-body">
    <!-- INFO -->
    <div *ngIf="drawerTab==='info'">
      <div class="panel mb-3">
        <h3 class="panel-title">Información en SAP</h3>
        <div class="dl">
          <div><span>Business Partner</span><b class="font-mono">{{ sel.business_partner || '—' }}</b></div>
          <div><span>Creación (FE.C)</span><b>{{ sel.fe_c ? (sel.fe_c | date:'short') : '—' }}</b></div>
          <div><span>Modificación (FE.M)</span><b>{{ sel.fe_m ? (sel.fe_m | date:'short') : '—' }}</b></div>
        </div>
        <div *ngIf="sel.last_error" class="text-red-600 text-xs mt-2">Último error: {{ sel.last_error }}</div>
      </div>

      <!-- Cuentas bancarias registradas (lo que se envía a SAP) -->
      <div class="panel mb-3" *ngIf="!showForm && payload?.d?.to_BusinessPartnerBank?.results?.length">
        <h3 class="panel-title">Cuentas bancarias</h3>
        <div class="dl">
          <div *ngFor="let b of payload.d.to_BusinessPartnerBank.results">
            <span>Banco {{ b.BankNumber }} · {{ b.BankControlKey === 'CA' ? 'Ahorro' : (b.BankControlKey === 'CC' ? 'Corriente' : b.BankControlKey) }}</span>
            <b class="font-mono">{{ b.BankAccount }}</b>
          </div>
        </div>
      </div>
      <div class="text-[11px] text-gray-400 mb-2" *ngIf="payload && !loadingPayload && !(payload?.d?.to_BusinessPartnerBank?.results?.length)">Sin cuentas bancarias registradas.</div>

      <div class="flex flex-wrap gap-2 mb-2" *ngIf="!showForm">
        <button (click)="drawerAnalizar()" [disabled]="actionBusy" class="btn-refresh"><i class="fas fa-magnifying-glass"></i> Analizar</button>
        <button (click)="drawerCrear()" [disabled]="actionBusy || loadingPayload || selAnalysis?.aprobado === false" class="btn-primary"
                [title]="selAnalysis?.aprobado === false ? 'El cliente no está aprobado; no se puede crear en SAP.' : (selCreado ? 'Reenvía el alta: si SAP responde que ya existe, se mantiene como creado.' : 'Crear el cliente en SAP.')"><i class="fas fa-cloud-arrow-up"></i> Crear en SAP</button>
        <button *ngIf="selCreado" (click)="abrirFormModificar()" [disabled]="actionBusy || loadingPayload" class="btn-primary"><i class="fas fa-pen"></i> Modificar</button>
        <button (click)="abrirFicha()" class="btn-ghost"><i class="fas fa-arrow-up-right-from-square"></i> Ficha completa</button>
      </div>
      <div *ngIf="selAnalysis?.aprobado === false && !showForm" class="text-xs rounded px-3 py-2 mb-2 bg-amber-50 text-amber-800 border border-amber-200">
        <i class="fas fa-ban mr-1"></i> El cliente no está aprobado; no se puede crear en SAP.
      </div>

      <div *ngIf="loadingPayload" class="text-xs text-gray-400 mb-2"><i class="fas fa-spinner fa-spin"></i> Cargando datos del cliente…</div>
      <div *ngIf="actionBusy" class="text-xs text-gray-500 mb-2"><i class="fas fa-spinner fa-spin"></i> Procesando…</div>
      <div *ngIf="actionMsg" class="text-sm rounded px-3 py-2 mb-3" [ngClass]="actionMsg.ok ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'">{{ actionMsg.text }}</div>

      <!-- Formulario de modificación -->
      <div *ngIf="showForm && edit" class="panel mb-3">
        <h3 class="panel-title">Modificar datos en SAP</h3>
        <div class="form-grid">
          <label class="fld"><span>Fecha de nacimiento</span><input type="date" [(ngModel)]="edit.birthDate" /></label>
          <label class="fld"><span>Profesión</span>
            <select [(ngModel)]="edit.BusinessPartnerOccupation">
              <option value="">—</option>
              <option *ngFor="let p of profesiones" [value]="p.code">{{ p.label }}</option>
            </select>
          </label>
          <label class="fld col-span-2"><span>Empresa / Empleador</span><input type="text" [(ngModel)]="edit.NaturalPersonEmployerName" placeholder="Opcional" /></label>
          <label class="fld col-span-2"><span>Correo</span><input type="email" [(ngModel)]="edit.EmailAddress" /></label>
          <label class="fld"><span>Teléfono 1</span><input type="text" [(ngModel)]="edit.phone1" placeholder="+58XXXXXXXXXX" /></label>
          <label class="fld"><span>Teléfono 2</span><input type="text" [(ngModel)]="edit.phone2" placeholder="Opcional" /></label>
        </div>

        <!-- Cuentas bancarias (editables — se envían en la modificación) -->
        <div *ngIf="modifyBanks.length" class="mt-3">
          <div class="text-[11px] text-gray-400 mb-1">Cuentas bancarias</div>
          <div *ngFor="let b of modifyBanks" class="form-grid mb-2">
            <label class="fld"><span>Banco</span><input type="text" [(ngModel)]="b.BankNumber" /></label>
            <label class="fld"><span>Cuenta</span><input type="text" [(ngModel)]="b.BankAccount" /></label>
            <label class="fld"><span>Titular</span><input type="text" [(ngModel)]="b.BankAccountHolderName" /></label>
            <label class="fld"><span>Tipo</span>
              <select [(ngModel)]="b.BankControlKey">
                <option value="CA">Ahorro (CA)</option>
                <option value="CC">Corriente (CC)</option>
              </select>
            </label>
          </div>
        </div>

        <p class="text-[11px] text-gray-400 mt-2">Nombre, estado civil y dirección los fija el sistema (no se envían en la modificación).</p>
        <div class="flex gap-2 mt-3">
          <button (click)="guardarModificacion()" [disabled]="actionBusy" class="btn-primary"><i class="fas fa-save"></i> Guardar en SAP</button>
          <button (click)="cancelarForm()" [disabled]="actionBusy" class="btn-ghost">Cancelar</button>
        </div>
      </div>

      <!-- Análisis -->
      <div *ngIf="selAnalysis && !showForm" class="panel">
        <h3 class="panel-title">Análisis</h3>
        <span class="badge" [ngClass]="selAnalysis.apto ? 'badge-ok' : 'badge-err'">{{ selAnalysis.apto ? 'Apto para SAP' : 'No apto' }}</span>
        <div *ngIf="selAnalysis.errores?.length" class="mt-2 space-y-1">
          <div *ngFor="let er of selAnalysis.errores" class="text-xs text-red-600">• {{ er.message }}</div>
        </div>
        <div *ngIf="!selAnalysis.errores?.length" class="text-xs text-gray-400 mt-1">Sin observaciones.</div>
      </div>
    </div>

    <!-- BITÁCORA -->
    <div *ngIf="drawerTab==='bitacora'">
      <div class="flex items-center justify-between mb-2">
        <span class="text-sm text-gray-500">{{ selLogs.length }} registro(s)</span>
        <button (click)="loadSelLogs()" [disabled]="loadingSelLogs" class="btn-mini"><i class="fas fa-sync-alt" [class.fa-spin]="loadingSelLogs"></i></button>
      </div>
      <div *ngIf="loadingSelLogs" class="text-xs text-gray-400"><i class="fas fa-spinner fa-spin"></i> Cargando…</div>
      <div *ngIf="!loadingSelLogs && selLogs.length===0" class="text-xs text-gray-400">Sin registros.</div>
      <div *ngFor="let l of selLogs" class="log-item">
        <div class="log-row" (click)="toggleLog(l)">
          <div class="min-w-0">
            <div class="text-sm font-medium text-gray-700">{{ l.action }}<span *ngIf="l.origen" class="text-gray-400 font-normal"> · {{ l.origen }}</span></div>
            <div class="text-xs text-gray-400">{{ l.createdAt | date:'short' }}<span *ngIf="l.reason"> · {{ l.reason }}</span></div>
          </div>
          <div class="flex items-center gap-2 flex-shrink-0">
            <span class="badge" [ngClass]="l.success ? 'badge-ok' : 'badge-err'">{{ l.success ? 'OK' : 'Error' }}</span>
            <i class="fas text-gray-300" [class.fa-chevron-down]="expandedLog!==l" [class.fa-chevron-up]="expandedLog===l"></i>
          </div>
        </div>
        <div *ngIf="expandedLog===l" class="log-detail">
          <div class="log-lbl">Enviado a SAP (request)</div>
          <pre class="log-pre">{{ pretty(l.request_payload) || '(vacío)' }}</pre>
          <div class="log-lbl">Respuesta de SAP</div>
          <pre class="log-pre">{{ l.sap_response != null ? pretty(l.sap_response) : '(sin respuesta de SAP)' }}</pre>
          <div class="log-lbl">Respuesta al frontend</div>
          <pre class="log-pre">{{ pretty(l.response_body) || '(vacío)' }}</pre>
        </div>
      </div>
    </div>
  </div>
</aside>
